
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import GruestForm from './gruest-form'

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            gruest: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentGru: {},
            codgruest: null,
        }
    },

    computed: {
        gruestList: function () {
            return this.$store.getters.getGruestList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleSubgru (gruest) {
            //abre a tela de edicao
            this.currentGru = gruest
            this.crud = SysVars.crudI;
            this.$set(gruest, 'subgru', true)
        },
        
        handleEdit (gruest) {
            //abre a tela de edicao
            this.currentGru = gruest
            this.crud = SysVars.crudU;
            this.$set(gruest, 'show', true)
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.showForm = true
        },

        closeForm() {
            this.currentGru.show = false
            this.currentGru.subgru = false
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = 'text=' + value
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadGruest', { query: this.filter } )
            this.offset = ''
        },

        handleDelete (gruest) {
            //BOTAO Excluir
            this.apiDelete(gruest)
        },

        async apiDelete (gruest) {
            //efetua a exclusao
            var modulo = 'cg/gruest/' + gruest.codgruest
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },


    },

    components: {
        BarList, GruestForm
    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Grupos de Produtos" 
                plural-entity="Grupos de Produtos"
                :hideSearch="true"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo nome do grupo">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="gruestList.length == 0" type="norecord"></alert>

                <div class="nb-card-inline-form mb-3" v-if="showForm">
                    <gruest-form :index="codgruest" :crud="crud" @closeform="closeForm"></gruest-form>
                </div>

                <article class="nb-card" v-for="gruest in gruestList" :key="gruest.codgruest">
                    <div class="nb-card-top" v-show="!gruest.show">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-cubes" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ gruest.descricao }}</h2>
                                    <span v-if="gruest.sub && gruest.sub.length" class="nb-card-badge nb-card-badge--info">
                                        {{ gruest.sub.length }} subgrupo(s)
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="gruest.codgruest">
                                    Código <strong>{{ gruest.codgruest }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <button type="button" class="btn btn-sm btn-outline-secondary" title="Alterar" @click="handleEdit(gruest)">
                                <i class="fa fa-pencil fa-fw"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" title="Excluir" @click="handleDelete(gruest)">
                                <i class="fa fa-trash fa-fw"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" title="Adicionar grupo filho" @click="handleSubgru(gruest)">
                                <i class="fa fa-plus fa-fw"></i> <span class="d-none d-sm-inline ml-1">Subgrupo</span>
                            </button>
                        </div>
                    </div>

                    <div class="nb-card-inline-form mt-2" v-if="gruest.show">
                        <gruest-form :index="gruest.codgruest" :crud="crud" @closeform="closeForm"></gruest-form>
                    </div>

                    <div class="nb-card-inline-form mt-2" v-if="gruest.subgru">
                        <gruest-form :pai="gruest" :crud="crud" @closeform="closeForm"></gruest-form>
                    </div>

                    <!-- SUBGRUPOS -->
                    <div class="nb-card-subitems" v-if="gruest.sub && gruest.sub.length">
                        <div class="nb-card-subitem" v-for="(sub, index) in gruest.sub" :key="index">
                            <div class="nb-card-subitem-top" v-if="!sub.show">
                                <div class="nb-card-subitem-identity">
                                    <i class="fa fa-level-up fa-rotate-90 nb-subitem-arrow" aria-hidden="true"></i>
                                    <span class="nb-subitem-title">{{ sub.descricao }}</span>
                                    <span class="nb-card-code ml-2" v-if="sub.codgruest">#{{ sub.codgruest }}</span>
                                </div>
                                <div class="nb-card-actions">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" title="Alterar" @click="handleEdit(sub)">
                                        <i class="fa fa-pencil fa-fw"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary" title="Excluir" @click="handleDelete(sub)">
                                        <i class="fa fa-trash fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="nb-card-inline-form mt-2" v-if="sub.show">
                                <gruest-form :index="sub.codgruest" :crud="crud" @closeform="closeForm"></gruest-form>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--info {
  color: #0369a1;
  background: #f0f9ff;
  border-color: #bae6fd;
}

.nb-card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.nb-card-actions .btn {
  color: #475569;
  border-color: #cbd5e1;
}

.nb-card-actions .btn:hover {
  color: #0f172a;
  background: #f1f5f9;
  border-color: #94a3b8;
}

.nb-card-subitems {
  margin-top: 12px;
  margin-left: 24px;
  padding-left: 16px;
  border-left: 2px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nb-card-subitem {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
}

.nb-card-subitem-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.nb-card-subitem-identity {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
}

.nb-subitem-arrow {
  color: #94a3b8;
  font-size: 14px;
}

.nb-subitem-title {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.nb-card-inline-form {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-subitems {
    margin-left: 10px;
    padding-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/gruest-list.vue